import { t } from 'i18n';
import { ApolloError } from '@apollo/client';

/**
 * 翻译后端 BUSINESS_ERROR 消息：
 * 1. 优先读取 ApolloError 的 extensions.messageKey
 * 2. 若没有 messageKey，则从错误文本中提取 errors.xxx
 * 3. 如果未命中翻译，返回兜底文案
 */
export const translateBackendError = (
    rawError?: unknown,
    fallbackKey: string = 'tms.task.drawer.saveFailed'
): string => {
    const fallback = t(fallbackKey);
    const messageText =
        rawError instanceof ApolloError
            ? (rawError.graphQLErrors[0]?.message || fallback)
            : typeof rawError === 'string'
                ? (rawError || fallback)
                : rawError instanceof Error
                    ? (rawError.message || fallback)
                    : rawError != null
                        ? String(rawError)
                        : fallback;
    const messageKey =
        (rawError instanceof ApolloError
            ? (rawError.graphQLErrors[0]?.extensions?.messageKey as string | undefined)
            : undefined) ||
        messageText.match(/(errors\.[A-Za-z0-9_.]+)/)?.[1];
    if (!messageKey) return messageText;
    const details = rawError instanceof ApolloError
        ? rawError.graphQLErrors[0]?.extensions?.details
        : undefined;
    const translated = t(messageKey, details);
    return translated !== messageKey ? translated : fallback;
};

